module.exports = __webpack_public_path__ + "static/a_man-0c78c97d138f569f8e02d6fe653e00e4.jpeg";